(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("moment"), require("levenshtein"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "moment", "levenshtein"], factory);
	else if(typeof exports === 'object')
		exports["TrivialComponents"] = factory(require("jquery"), require("moment"), require("levenshtein"));
	else
		root["TrivialComponents"] = factory(root["jQuery"], root["moment"], root["Levenshtein"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__15__) {
return 